module.exports = __webpack_public_path__ + "static/img/产品方案BG.d30e6f12.jpg";